import { gql } from '@apollo/client';

/**
 * GraphQL mutation for deleting a community
 */
export const DELETE_COMMUNITY_GROUP = gql`
  mutation DeleteCommunityGroup($id: ID!) {
    deleteCommunityGroup(id: $id) {
      success
      message
    }
  }
`;
